import { API_BASE_URL } from '../../../config';

// สายของร้านที่ถือถัง — live from customer_buy_rutine (customer → route uid) + the route registry
// (uid → name), never copied onto the tank. A shop can be on several routes. Keys are customer
// codes (REC-…), the same value the tank row carries in customerCode. Rejects on any failure so
// the page can say "load failed" instead of showing a wrong "ไม่มีสาย".
export const loadRoutesByCustomer = async (headers) => {
    const res = await fetch(`${API_BASE_URL}/customer/api/customer-buy-rutine/all`, { headers });
    if (!res.ok) throw new Error(String(res.status));
    const rows = (await res.json()).filter((r) => r.customerId && r.sellerId);
    const sellerIds = [...new Set(rows.map((r) => r.sellerId))];
    const nameBySeller = {};
    if (sellerIds.length > 0) {
        const namesRes = await fetch(`${API_BASE_URL}/customer/api/customers/seller-names`, {
            method: 'POST', headers, body: JSON.stringify(sellerIds),
        });
        if (!namesRes.ok) throw new Error(String(namesRes.status));
        (await namesRes.json()).forEach((n) => { if (n.nameuser) nameBySeller[n.Seller_ID] = n.nameuser; });
    }
    const out = {};
    rows.forEach((r) => {
        const n = nameBySeller[r.sellerId];
        if (n && !(out[r.customerId] || []).includes(n)) (out[r.customerId] = out[r.customerId] || []).push(n);
    });
    return out;
};

// What the "สาย" column shows. routesByCustomer null = still loading / failed.
export const routeText = (tank, routesByCustomer, failed) => {
    if (!tank.customerCode) return '-';
    if (!routesByCustomer) return failed ? 'โหลดสายไม่สำเร็จ' : '…';
    const names = routesByCustomer[tank.customerCode] || [];
    return names.length > 0 ? names.join(', ') : 'ไม่มีสาย';
};
